export default "__VITE_ASSET__B7CzEThV__"